import React, {useState} from 'react';
import ModalWindow from '../modal-window';
import {useIntl} from 'react-intl';
import {ButtonVariant, GritxButton} from '@wholesalechange/chatcomponent';
import Input from '../input';

import './style.scss';
import InputDate from '../input-date';
import {InputTime} from '../input-time/InputTime';
import {ISearchDialogue} from '../../redux/search/interfaces';

interface ISearchModalWindow {
  dialogueCard: ISearchDialogue
  title: string
  onSave: (dialogue: ISearchDialogue) => void
  onClose: () => void
  show: boolean
}

export const SearchModalWindow = (
  {
    dialogueCard,
    title,
    onSave,
    onClose,
    show
  }: ISearchModalWindow
): JSX.Element => {
  const intl = useIntl();
  const [dialogue, setDialogue] = useState<ISearchDialogue>(dialogueCard);

  function handleClose() {
    setDialogue(dialogueCard);
    onClose();
  }

  const getValidFormStatus = (): boolean => {
    return !!dialogue.dialogName && dialogue.dialogName.trim() !== '' && !!dialogue.dialogUserDate;
  };

  function handleSave() {
    if (getValidFormStatus()) {
      onSave(dialogue);
    }
  }

  function handleChange(type: string): (e: string) => void {
    return (e) => {
      const newDialogue = {
        ...dialogue,
        [type]: e
      };

      setDialogue(newDialogue);
    };
  }

  function handleChangeDate(type: string): (e: Date) => void {
    return (e) => {
      const newDialogue = {
        ...dialogue,
        [type]: e
      };

      setDialogue(newDialogue);
    };
  }

  function handleChangeTime(type: string): (e: Date) => void {
    return (e) => {
      const newDialogue = {
        ...dialogue,
        [type]: e
      };

      setDialogue(newDialogue);
    };
  }

  const content = () => {
    return <div className={'search-form__container'}>
      <div className={'form-search'}>
        <div className="form-search__header">
          <h2 className="form-search__title">{title}</h2>
        </div>
        <div className="form-search__body">
          <Input
            required
            type="text"
            value={dialogue.dialogName}
            label={intl.formatMessage({
              id: 'gritx.search.card.name.label',
              defaultMessage: 'Name'
            })}
            onChange={handleChange('dialogName')}
          />

          <InputDate
            required
            value={dialogue.dialogUserDate}
            label={intl.formatMessage({
              id: 'gritx.search.card.date.label',
              defaultMessage: 'Date'
            })}
            onChange={handleChangeDate('dialogUserDate')}
          />

          <InputTime
            required
            value={dialogue.dialogUserDate}
            label={intl.formatMessage({
              id: 'gritx.search.card.time.label',
              defaultMessage: 'Time'
            })}
            onChange={handleChangeTime('dialogUserDate')}
          />
        </div>
      </div>
    </div>;
  };

  const formsButtons = () => {
    return <div className="search-form__footer">
      <GritxButton
        title={intl.formatMessage({
          id: 'gritx.common.button.cancel',
          defaultMessage: 'Cancel'
        })}
        variant={ButtonVariant.Light}
        className="search-form__button"
        onClick={handleClose}
      />
      <GritxButton
        title={intl.formatMessage({
          id: 'gritx.common.button.save',
          defaultMessage: 'Save'
        })}
        variant={ButtonVariant.Primary}
        className="search-form__button"
        onClick={handleSave}
      />
    </div>;
  };

  return <ModalWindow
    show={show}
    className="search-form__modal"
    onHide={handleClose}
    footerElement={formsButtons()}
  >
    {content()}
  </ModalWindow>;
};
